import React, { useCallback, useContext, useEffect, useMemo, useState } from 'react';
import type { NextPage } from 'next';
import styles from './index.module.scss';
import Image from "next/image";
import cName from "classnames";
import 'swiper/css'
import 'swiper/css/pagination'
import 'swiper/css/navigation';
import { Pagination, Autoplay, Navigation } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import Wrapper from '@/components/wrapper';
import * as echarts from 'echarts';
import CountUp from 'react-countup';
import request from '@/utils/request';
import { getServerSideProps as _getServerSideProps, getHead } from '@/utils/useHead';
import { useTranslations } from "next-intl";
import { useRouter } from "next/router";

interface IProps {

}

export async function getServerSideProps(context: any) {
  const res: any = await _getServerSideProps(context);
  const { data } = await request.get(`/api/get_review`, {
    params: {
      lang: context.locale || context.defaultLocale || 'cn'
    }
  })
  return {
    props: {
      ...res.props,
      data: data?.data || null
    }
  }
}

const Lookback: NextPage<IProps> = ({ menuDetail, data }: any) => {
  const router = useRouter();
  const t = useTranslations("about.lookback");

  const audiPieOption = {
    title: {
      text: t('section5.chart1.title'),
      subtext: t('section5.chart1.subtext'),
      x: 'center',
      y: '165',
      itemGap: 0,
      textStyle: {
        fontFamily: '微软雅黑',
        fontSize: 28,
        fontWeight: 'bolder',
      },
      subtextStyle: {
        color: 'eee',
        fontSize: 28,
        fontWeight: 'bolder',
      }
    },
    tooltip: {
      trigger: 'item'
    },
    series: [
      {
        name: '',
        type: 'pie',
        radius: ['55%', '80%'],
        animationDuration: 2500,
        startAngle: 80,
        data: [
          {
            value: t('section5.chart1.item1num'), name: t('section5.chart1.item1tit'), itemStyle: {
              color: new echarts.graphic.LinearGradient(
                0, 0, 0, 1,
                [
                  { offset: 0, color: '#f3af4a' },
                  { offset: 1, color: '#f8f3bd' }
                ]
              )
            }
          },
          {
            value: t('section5.chart1.item2num'), name: t('section5.chart1.item2tit'), itemStyle: {
              color: '#f5c352'
            }
          },
          { value: t('section5.chart1.item3num'), name: t('section5.chart1.item3tit'), itemStyle: { color: '#c9741c' } },
          { value: t('section5.chart1.item4num'), name: t('section5.chart1.item4tit'), itemStyle: { color: '#e36819' } },
          { value: t('section5.chart1.item5num'), name: t('section5.chart1.item5tit'), itemStyle: { color: '#f18c1b' } },
          // {
          //   value: t('section5.chart1.item6num'), name: t('section5.chart1.item6tit'), itemStyle: {
          //     color: new echarts.graphic.LinearGradient(
          //       0, 0, 0, 1,
          //       [
          //         { offset: 0, color: '#f6dc59' },
          //         { offset: 1, color: '#f8f2bd' }
          //       ]
          //     )
          //   }
          // },
        ],
        emphasis: {
          itemStyle: {
            shadowBlur: 10,
            shadowOffsetX: 0,
            shadowColor: 'rgba(0, 0, 0, 0.5)'
          }
        },
        labelLine: {
          // show: false
          normal: {
            length: 30
          }
        },
        label: {
          show: true,
          formatter: function (params: any) {
            return '{a|' + params.value + '%}' + '\n' + '{b|' + params.name + '}';
          },
          offset: [0, 0],
          overflow: 'none',
          rich: {
            a: {
              color: '#fcb814',
              fontSize: '24px',
              lineHeight: 30,
              fontWeight: 'bold',
              align: 'left'
            },
            b: {
              color: '#666',
              fontSize: '14px',
              fontWeight: 'normal',
              align: 'center'
            }
          },
        },

      }
    ]
  }
  const exhPie1Option = {
    title: {
      text: '设备',
      x: 'center',
      y: 'center',
      itemGap: 0,
      textStyle: {
        fontFamily: '微软雅黑',
        fontSize: 28,
        fontWeight: 'bolder',
      },
    },
    tooltip: {
      trigger: 'item'
    },
    series: [
      {
        name: '',
        type: 'pie',
        radius: ['44%', '69%'],
        animationDuration: 2500,
        data: [
          {
            value: t('section8.chart1.item1num'), name: t('section8.chart1.item1tit'), itemStyle: {
              color: new echarts.graphic.LinearGradient(
                0, 0, 0, 1,
                [
                  { offset: 0, color: '#f3af4a' },
                  { offset: 1, color: '#f8f3bd' }
                ]
              )
            }
          },
          {
            value: t('section8.chart1.item2num'), name: t('section8.chart1.item2tit'), itemStyle: {
              color: '#f5c352'
            }
          },
          { value: t('section8.chart1.item3num'), name: t('section8.chart1.item3tit'), itemStyle: { color: '#c9741c' } },
          { value: t('section8.chart1.item4num'), name: t('section8.chart1.item4tit'), itemStyle: { color: '#e36819' } },
          {
            value: t('section8.chart1.item5num'), name: t('section8.chart1.item5tit'), itemStyle: {
              color: new echarts.graphic.LinearGradient(
                0, 0, 0, 1,
                [
                  { offset: 0, color: '#f6dc59' },
                  { offset: 1, color: '#f8f2bd' }
                ]
              )
            }
          },
        ],
        emphasis: {
          itemStyle: {
            shadowBlur: 10,
            shadowOffsetX: 0,
            shadowColor: 'rgba(0, 0, 0, 0.5)'
          }
        },
        labelLine: {
          // show: false
          normal: {
            length: 30
          }
        },
        label: {
          show: true,
          formatter: function (params: any) {
            return '{a|' + params.value + '%}' + '\n' + '{b|' + params.name + '}';
          },
          offset: [0, 0],
          overflow: 'none',
          rich: {
            a: {
              color: '#fcb814',
              fontSize: '24px',
              lineHeight: 30,
              fontWeight: 'bold',
              align: 'left'
            },
            b: {
              color: '#666',
              fontSize: '14px',
              fontWeight: 'normal',
              align: 'center'
            }
          },
        },

      }
    ]
  }
  const exhPie2Option = {
    title: {
      text: t('section8.chart2.title'),
      x: 'center',
      y: 'center',
      itemGap: 0,
      textStyle: {
        fontFamily: '微软雅黑',
        fontSize: 28,
        fontWeight: 'bolder',
      },
    },
    tooltip: {
      trigger: 'item'
    },
    series: [
      {
        name: '',
        type: 'pie',
        radius: ['44%', '69%'],
        animationDuration: 2500,
        data: [
          {
            value: t('section8.chart2.item1num'), name: t('section8.chart2.item1tit'), itemStyle: {
              color: new echarts.graphic.LinearGradient(
                0, 0, 0, 1,
                [
                  { offset: 0, color: '#f3af4a' },
                  { offset: 1, color: '#f8f3bd' }
                ]
              )
            }
          },
          {
            value: t('section8.chart2.item2num'), name: t('section8.chart2.item2tit'), itemStyle: {
              color: '#e36819'
            }
          },
          { value: t('section8.chart2.item3num'), name: t('section8.chart2.item3tit'), itemStyle: { color: '#c9741c' } },
          {
            value: t('section8.chart2.item4num'), name: t('section8.chart2.item4tit'), itemStyle: {
              color: new echarts.graphic.LinearGradient(
                0, 0, 0, 1,
                [
                  { offset: 0, color: '#f6dc59' },
                  { offset: 1, color: '#f8f2bd' }
                ]
              ),

            }
          },
        ],
        emphasis: {
          itemStyle: {
            shadowBlur: 10,
            shadowOffsetX: 0,
            shadowColor: 'rgba(0, 0, 0, 0.5)'
          }
        },
        labelLine: {
          // show: false
          normal: {
            length: 30
          }
        },
        label: {
          show: true,
          formatter: function (params: any) {
            return '{a|' + params.value + '%}' + '\n' + '{b|' + params.name + '}';
          },
          offset: [0, 0],
          overflow: 'none',
          rich: {
            a: {
              color: '#fcb814',
              fontSize: '24px',
              lineHeight: 30,
              fontWeight: 'bold',
              align: 'left'
            },
            b: {
              color: '#666',
              fontSize: '14px',
              fontWeight: 'normal',
              align: 'center'
            }
          },
        },

      }
    ]
  }
  const exhPie3Option = {
    title: {
      text: t('section8.chart3.title'),
      subtext: t('section8.chart3.subtext'),
      x: 'center',
      y: '165',
      itemGap: 0,
      textStyle: {
        fontFamily: '微软雅黑',
        fontSize: 28,
        fontWeight: 'bolder',
      },
      subtextStyle: {
        color: 'eee',
        fontSize: 28,
        fontWeight: 'bolder',
      }
    },
    tooltip: {
      trigger: 'item'
    },
    series: [
      {
        name: '',
        type: 'pie',
        radius: ['44%', '69%'],
        animationDuration: 2500,
        startAngle: 0,
        data: [
          {
            value: t('section8.chart3.item1num'), name: t('section8.chart3.item1tit'), itemStyle: {
              color: new echarts.graphic.LinearGradient(
                0, 0, 0, 1,
                [
                  { offset: 0, color: '#f3af4a' },
                  { offset: 1, color: '#f8f3bd' }
                ]
              )
            }
          },
          {
            value: t('section8.chart3.item2num'), name: t('section8.chart3.item2tit'), itemStyle: {
              color: '#f18c1b'
            }
          },
          { value: t('section8.chart3.item3num'), name: t('section8.chart3.item3tit'), itemStyle: { color: '#c9741c' } },
          {
            value: t('section8.chart3.item4num'), name: t('section8.chart3.item4tit'), itemStyle: {
              color: new echarts.graphic.LinearGradient(
                0, 0, 0, 1,
                [
                  { offset: 0, color: '#f6dc59' },
                  { offset: 1, color: '#f8f2bd' }
                ]
              )
            }
          },
        ],
        emphasis: {
          itemStyle: {
            shadowBlur: 10,
            shadowOffsetX: 0,
            shadowColor: 'rgba(0, 0, 0, 0.5)'
          }
        },
        labelLine: {
          // show: false
          normal: {
            length: 30
          }
        },
        label: {
          show: true,
          formatter: function (params: any) {
            return '{a|' + params.value + '%}' + '\n' + '{b|' + params.name + '}';
          },
          offset: [0, 0],
          overflow: 'none',
          rich: {
            a: {
              color: '#fcb814',
              fontSize: '24px',
              lineHeight: 30,
              fontWeight: 'bold',
              align: 'left'
            },
            b: {
              color: '#666',
              fontSize: '14px',
              fontWeight: 'normal',
              align: 'center'
            }
          },
        },

      }
    ]
  }
  const audiBarOption = {
    tooltip: {
      trigger: 'axis',
      formatter: function (params: any) {
        // 假设 params.seriesName 是实际数据的系列名
        if (params[0].seriesName == 'data') {
          // 只返回实际数据的值
          return (
            params[0].name +
            '<br/>' +
            params[0].seriesName +
            ': ' +
            params[0].value +
            '%'
          );
        }
        // 对于剩余部分的数据，不返回任何内容，这样 tooltip 就不会显示
        return '';
      }
    },
    legend: {
      data: ['柱状图1', '柱状图2']
    },
    xAxis: [
      {
        type: 'value',
        boundaryGap: [0],
        position: 'top',
        data: ['总量'],
        max: 100,
        // scale: 0.8,
        axisLine: {
          show: false // 是否显示坐标轴线
        },
        axisTick: {
          // 控制刻度
          show: false // 不显示刻度
        },
        axisLabel: {
          // 控制坐标轴标签
          show: false // 不显示坐标轴标签
        },
        splitLine: {
          // 控制网格线
          show: false // 不显示网格线
        }
      }
    ],
    yAxis: [
      {
        type: 'category',
        max: 9,
        data: [
          t('section5.chart2.item1tit'),
          t('section5.chart2.item2tit'),
          t('section5.chart2.item3tit'),
          t('section5.chart2.item4tit'),
          t('section5.chart2.item5tit'),
          t('section5.chart2.item6tit'),
          t('section5.chart2.item7tit'),
          t('section5.chart2.item8tit'),
          t('section5.chart2.item9tit'),
          t('section5.chart2.item10tit'),
        ],
        axisLabel: {
          fontSize: '14px',
          lineHeight: 20,
          align: 'right',
          margin: 10,
          color: '#666'
        },
        axisTick: {
          show: false
        },
        axisLine: {
          show: false,
          lineStyle: {
            color: '#f5f5f5'
          }
        }
      }
    ],
    series: [
      {
        name: 'data',
        type: 'bar',
        // barGap: ,
        barGap: '-100%',
        barCategoryGap: '60%',
        animationDuration: 2500,
        // stack: '总量',
        itemStyle: {
          color: '#fcb814',
          barBorderRadius: 20
        },
        z: 10,
        data: [
          t('section5.chart2.item1num'),
          t('section5.chart2.item2num'),
          t('section5.chart2.item3num'),
          t('section5.chart2.item4num'),
          t('section5.chart2.item5num'),
          t('section5.chart2.item6num'),
          t('section5.chart2.item7num'),
          t('section5.chart2.item8num'),
          t('section5.chart2.item9num'),
          t('section5.chart2.item10num'),
        ]
      },
      {
        name: '剩余部分',
        type: 'bar',
        // stack: '总量',
        label: {
          show: true,
          position: 'right',
          formatter: function (params: any,) {
            const data = [
              t('section5.chart2.item1num'),
              t('section5.chart2.item2num'),
              t('section5.chart2.item3num'),
              t('section5.chart2.item4num'),
              t('section5.chart2.item5num'),
              t('section5.chart2.item6num'),
              t('section5.chart2.item7num'),
              t('section5.chart2.item8num'),
              t('section5.chart2.item9num'),
              t('section5.chart2.item10num'),
            ]
            var percent = data[params.dataIndex] + '%'; // 计算并格式化占比
            return '{a|' + percent + '}';
          },
          rich: {
            a: {
              fontSize: 16,
              color: '#333',
              fontFamily: '微软雅黑',
              fontWeight: '500'
            }
          },
          // padding: [4, 8, 1]
        },
        itemStyle: {
          color: '#fee3a1',
          barBorderRadius: 20,
        },
        data: (function () {
          return Array(10).fill(100);
        })()
      }
    ],
    grid: {
      top: '0',
      left: '0',
      right: '65',
      bottom: '0',
      containLabel: true
    }
  }

  const chunkArray = useCallback((arr: any, chunkSize: number) => {
    const chunkedArray = [];
    let index = 0;
    while (index < arr.length) {
      const end = Math.min(index + chunkSize, arr.length);
      chunkedArray.push(arr.slice(index, end));
      index = end;
    }
    return chunkedArray;
  }, [])

  useEffect(() => {
    const audiPie = echarts.init(document.getElementById('audiPie'))
    audiPie.setOption(audiPieOption)
    const audiBar = echarts.init(document.getElementById('audiBar'))
    audiBar.setOption(audiBarOption)
    const exhPie1 = echarts.init(document.getElementById('exhPie1'))
    exhPie1.setOption(exhPie1Option)
    const exhPie2 = echarts.init(document.getElementById('exhPie2'))
    exhPie2.setOption(exhPie2Option)
    const exhPie3 = echarts.init(document.getElementById('exhPie3'))
    exhPie3.setOption(exhPie3Option)
  }, [])

  return (
    <div>
      <Wrapper>
        <div className={cName(styles.container, 'm-1600')}>
          {getHead(menuDetail)}
          <div className={styles.intro}>
            <div className={styles.left}>
              <h2>{t('section1.title')}</h2>
              <div className={styles.info}>
                <div className={styles.time}>{t('section1.date')}</div>
                <div className={styles.site}>{t('section1.address')}</div>
              </div>
              <p dangerouslySetInnerHTML={{ __html: t('section1.text') }}></p>
              <div className={styles.line}></div>
              <ul>
                <li>
                  <img loading='lazy' src="/image/scalability.png" alt="" />
                  <div>
                    <p><CountUp
                      end={parseInt(t('section1.item1num'))}
                      duration={1}
                      enableScrollSpy
                    /><span style={{ fontSize: '24px' }}>{t('section1.item1unit')}</span></p>
                    <span>{t('section1.item1tit')}</span>
                  </div>
                </li>
                <li>
                  <img loading='lazy' src="/image/beer-bottle.png" alt="" />
                  <div>
                    <p><CountUp
                      end={parseInt(t('section1.item2num'))}
                      duration={1}
                      enableScrollSpy
                    /><span>{t('section1.item2unit')}</span></p>
                    <span>{t('section1.item2tit')}</span>
                  </div>
                </li>
                <li>
                  <img loading='lazy' src="/image/users.png" alt="" />
                  <div>
                    <p><CountUp
                      end={parseInt(t('section1.item3num'))}
                      duration={1}
                      enableScrollSpy
                    /><span style={{ fontSize: '24px' }}>{t('section1.item3unit')}</span></p>
                    <span>{t('section1.item3tit')}</span>
                  </div>
                </li>
                <li>
                  <img loading='lazy' src="/image/calendar.png" alt="" />
                  <div>
                    <p><CountUp
                      end={parseInt(t('section1.item4num'))}
                      duration={1}
                      enableScrollSpy
                    /><span style={{ fontSize: '24px' }}>{t('section1.item4unit')}</span></p>
                    <span>{t('section1.item4tit')}</span>
                  </div>
                </li>
              </ul>
            </div>
            <div className={styles.right}>
              <div className={styles.videoBox}>
                <video src="https://img.cbcechina.com/2026-05-28/87961ff87ecfd343b5ef332336e33ff5.mp4"
                  loop
                  muted
                  playsInline
                  controls
                  poster="https://img.cbcechina.com/2024-12-10/ca7c7b2fc08900805c65caebef9d183c.png"></video>
              </div>
            </div>
          </div>
          <div className={styles.lookBox}>
            <h2>{t('section2.title')}</h2>
            <Swiper
              onObserverUpdate={(swiper: any) => {
                swiper.slideNext()
              }}
              autoplay
              className='lookback'
              modules={[Autoplay, Pagination]}
              slidesPerView='auto'
              pagination={{ clickable: true }}
            >
              {
                data.review_list?.map((item: any, index: number) => (
                  <SwiperSlide key={index}>
                    <a href={item.file} target='_blank' className={styles.lookItem}>
                      <p>{item.title}<span>{t('section2.unit')}</span></p>
                      <span>{t('section2.label')}</span>
                      <div className={styles.bg} style={{
                        opacity: `${1 - index * 0.09}`
                      }}></div>
                    </a>
                  </SwiperSlide>
                ))
              }
            </Swiper>
          </div>
          <div className={styles.news}>
            <h2>{t('section3.title')}</h2>
            <div className={styles.newsBox}>
              <Swiper
                className='news'
                autoplay
                modules={[Autoplay, Pagination]}
                pagination={{ clickable: true }}
                breakpoints={
                  {
                    0: {
                      slidesPerView: 1,
                    },
                    1000: {
                      slidesPerView: 2,
                    },
                  }
                }
                spaceBetween={5}
              >
                {
                  data.new_list?.map((item: any, index: number) => (
                    <SwiperSlide key={index}>
                      <a href={`/media/news/news_detail/${item.id}`}>
                        <div className={styles.newsItem} key={item.id}>
                          <img loading='lazy' src={item.info.image} alt={item.info.title} />
                          <div className={styles.right}>
                            <h3>{item.info.title}</h3>
                            <p>{item.info.brief}</p>
                            <span>{new Date(String(item.publish_time).length === 10 ?
                              item.publish_time * 1000 : item.publish_time
                            ).toLocaleString().replace(/\//g, '-').split(' ')[0]}</span>
                          </div>
                        </div>
                      </a>
                    </SwiperSlide>
                  ))
                }
              </Swiper>
            </div>
          </div>
          <div className={styles.audience}>
            <h2>{t('section4.title')}</h2>
            <Swiper
              className={styles.swiper}
              modules={[Autoplay, Pagination]}
              spaceBetween={0}
              autoplay
              pagination={{ clickable: true }}
              slidesPerView={1}
            >
              {
                data.spectator_list &&
                chunkArray(data.spectator_list, 24)
                  ?.map((item: any, index: number) => (
                    <SwiperSlide key={index}>
                      <div className={styles.audiList}>
                        {
                          item.map((child: any, idx: number) => (
                            <a href={child[`link_${router.locale}`] ? child[`link_${router.locale}`] : "javascript:;"} target={child[`link_${router.locale}`] ? '_blank' : '_self'} key={idx}>
                              <img loading='lazy' src={child.image} alt={child[`title_${router.locale}`]} />
                            </a>
                          ))
                        }
                      </div>
                    </SwiperSlide>
                  ))
              }
            </Swiper>
          </div>
          <div className={styles.aboutAudi}>
            <h2>{t('section5.title')}</h2>
            <div className={styles.data}>
              <div id='audiPie' className={styles.pie} />
              <div className={styles.bar}>
                <h4>{t('section5.chart2.title')}</h4>
                <div id='audiBar' className={styles.audiBar} />
              </div>
              <div className={styles.right}>
                <h4>{t('section5.chart3.title')}</h4>
                <ul className={styles.list}>
                  <li className={styles.item}>
                    <img className={styles.icon} src="/image/cup1.png" />
                    <div>
                      <p className={styles.num}>
                        <CountUp end={Number(t('section5.chart3.item1num'))} duration={1} enableScrollSpy decimals={2} />
                        <span className={styles.unit}>{t('section5.chart3.item1unit')}</span>
                      </p>
                      <p className={styles.label}>{t('section5.chart3.item1tit')}</p>
                    </div>
                  </li>
                  <li className={styles.item}>
                    <img className={styles.icon} src="/image/cup4.png" />
                    <div>
                      <p className={styles.num}>
                        <CountUp end={Number(t('section5.chart3.item2num'))} duration={1} enableScrollSpy decimals={2} />
                        <span className={styles.unit}>{t('section5.chart3.item2unit')}</span>
                      </p>
                      <p className={styles.label}>{t('section5.chart3.item2tit')}</p>
                    </div>
                  </li>
                  <li className={styles.item}>
                    <img className={styles.icon} src="/image/cup3.png" />
                    <div>
                      <p className={styles.num}>
                        <CountUp end={Number(t('section5.chart3.item3num'))} duration={1} enableScrollSpy decimals={2} />
                        <span className={styles.unit}>{t('section5.chart3.item3unit')}</span>
                      </p>
                      <p className={styles.label}>{t('section5.chart3.item3tit')}</p>
                    </div>
                  </li>
                  <li className={styles.item}>
                    <img className={styles.icon} src="/image/cup1.png" />
                    <div>
                      <p className={styles.num}>
                        <CountUp end={Number(t('section5.chart3.item4num'))} duration={1} enableScrollSpy decimals={2} />
                        <span className={styles.unit}>{t('section5.chart3.item4unit')}</span>
                      </p>
                      <p className={styles.label}>{t('section5.chart3.item4tit')}</p>
                    </div>
                  </li>
                  <li className={styles.item}>
                    <img className={styles.icon} src="/image/cup4.png" />
                    <div>
                      <p className={styles.num}>
                        <CountUp end={Number(t('section5.chart3.item5num'))} duration={1} enableScrollSpy decimals={2} />
                        <span className={styles.unit}>{t('section5.chart3.item5unit')}</span>
                      </p>
                      <p className={styles.label}>{t('section5.chart3.item5tit')}</p>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div className={styles.comment}>
            <div className={styles.buyerComment}>
              <h2>{t('section6.left.title')}</h2>
              <div>
                <span className={styles.leftTop}>“</span>
                <span className={styles.rightBottom}>”</span>
                <Swiper
                  className='comment'
                  modules={[Autoplay, Pagination]}
                  slidesPerView={1}
                  spaceBetween={10}
                  pagination={{ clickable: true }}
                >
                  <SwiperSlide>
                    <div className={styles.commentItem}>
                      <p className={styles.name}>{t('section6.left.item1name')}</p>
                      <span>{t('section6.left.item1title')}</span>
                      <hr color='#dea210' />
                      <p>{t('section6.left.item1text')}</p>
                    </div>
                  </SwiperSlide>
                  <SwiperSlide>
                    <div className={styles.commentItem}>
                      <p className={styles.name}>{t('section6.left.item2name')}</p>
                      <span>{t('section6.left.item2title')}</span>
                      <hr color='#dea210' />
                      <p>{t('section6.left.item2text')}</p>
                    </div>
                  </SwiperSlide>
                  <SwiperSlide>
                    <div className={styles.commentItem}>
                      <p className={styles.name}>{t('section6.left.item3name')}</p>
                      <span>{t('section6.left.item3title')}</span>
                      <hr color='#dea210' />
                      <p>{t('section6.left.item3text')}</p>
                    </div>
                  </SwiperSlide>
                </Swiper>
              </div>
            </div>
            <div className={styles.exhComment}>
              <h2>{t('section6.right.title')}</h2>
              <div>
                <span className={styles.leftTop}>“</span>
                <span className={styles.rightBottom}>”</span>
                <Swiper
                  className='comment exhComment'
                  modules={[Autoplay, Pagination]}
                  slidesPerView={1}
                  spaceBetween={10}
                  pagination={{ clickable: true }}
                >
                  <SwiperSlide>
                    <div className={styles.commentItem}>
                      <p className={styles.name}>{t('section6.right.item1name')}</p>
                      <span>{t('section6.right.item1title')}</span>
                      <hr color='#3e3a3b' />
                      <p>{t('section6.right.item1text')}</p>
                    </div>
                  </SwiperSlide>
                  <SwiperSlide>
                    <div className={styles.commentItem}>
                      <p className={styles.name}>{t('section6.right.item2name')}</p>
                      <span>{t('section6.right.item2title')}</span>
                      <hr color='#3e3a3b' />
                      <p>{t('section6.right.item2text')}</p>
                    </div>
                  </SwiperSlide>
                  <SwiperSlide>
                    <div className={styles.commentItem}>
                      <p className={styles.name}>{t('section6.right.item3name')}</p>
                      <span>{t('section6.right.item3title')}</span>
                      <hr color='#3e3a3b' />
                      <p>{t('section6.right.item3text')}</p>
                    </div>
                  </SwiperSlide>
                </Swiper>
              </div>
            </div>
          </div>
          <div className={styles.audience}>
            <h2>{t('section7.title')}</h2>
            <Swiper
              className={styles.swiper}
              modules={[Autoplay, Pagination]}
              spaceBetween={0}
              autoplay
              pagination={{ clickable: true }}
              slidesPerView={1}
            >
              {
                data.brand_list &&
                chunkArray(data.brand_list, 24)
                  ?.map((item: any, index: number) => (
                    <SwiperSlide key={index}>
                      <div className={styles.audiList}>
                        {
                          item.map((child: any, idx: number) => (
                            <a href={child[`link_${router.locale}`] ? child[`link_${router.locale}`] : "javascript:;"} target={child[`link_${router.locale}`] ? '_blank' : '_self'} key={idx}>
                              <img loading='lazy' src={child.image} alt={child[`title_${router.locale}`]} />
                            </a>
                          ))
                        }
                      </div>
                    </SwiperSlide>
                  ))
              }
            </Swiper>
          </div>
          <div className={styles.exhData}>
            <h2>{t('section8.title')}</h2>
            <div>
              <div id='exhPie1' className={styles.pie} />
              <div id='exhPie2' className={styles.pie} />
              <div id='exhPie3' className={styles.pie} />
            </div>
          </div>
          <div className={styles.banner}>
            <div>
              <a href="/exhibition/download">
                <img src="https://img.cbcechina.com/2025-07-18/1ccfe79242732824f49421001b129368.jpg" alt="" />
              </a>
            </div>
          </div>
          <div className={styles.photo}>
            <h2>{t('section9.title')}</h2>
            {data.exhibition_atlas_list && <div className={styles.photoList}>
              <div className={styles.top}>
                <img loading='lazy' src={data.exhibition_atlas_list[0].photo} alt="" />
                <div>
                  <img loading='lazy' src={data.exhibition_atlas_list[1].photo} alt="" />
                  <img loading='lazy' src={data.exhibition_atlas_list[2].photo} alt="" />
                </div>
                <img loading='lazy' src={data.exhibition_atlas_list[3].photo} alt="" />
              </div>
              <div className={styles.bottom}>
                <div>
                  <img loading='lazy' src={data.exhibition_atlas_list[4].photo} alt="" />
                  <img src={data.exhibition_atlas_list[5].photo} alt="" />
                </div>
                <img loading='lazy' src={data.exhibition_atlas_list[6].photo} alt="" />
                <img loading='lazy' src={data.exhibition_atlas_list[7].photo} alt="" />
                <img loading='lazy' src={data.exhibition_atlas_list[8].photo} alt="" />
              </div>
            </div>}
            <a href="/media/photo">
              <div className={cName([styles.more, 'btnStyle'])}>
                <span>{t('section9.more')}</span>
                {/* @ts-ignore */}
                <svg t="1723196878237" className="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2672" width="14" height="14">
                  <path d="M320 0 192 128l384 384-384 384 128 128 512-512L320 0z" p-id="2673" fill="#231F20">
                  </path>
                </svg>
              </div>
            </a>
          </div>
          <div className={styles.audience}>
            <h2>{t('section10.title')}</h2>
            <Swiper
              className={styles.swiper}
              modules={[Autoplay, Pagination]}
              spaceBetween={0}
              autoplay
              pagination={{ clickable: true }}
              slidesPerView={1}
            >
              {
                data.medium_list &&
                chunkArray(data.medium_list, 24)
                  ?.map((item: any, index: number) => (
                    <SwiperSlide key={index}>
                      <div className={styles.audiList}>
                        {
                          item.map((child: any, idx: number) => (
                            <a href={child[`link_${router.locale}`] ? child[`link_${router.locale}`] : "javascript:;"} target={child[`link_${router.locale}`] ? '_blank' : '_self'} key={idx}>
                              <img loading='lazy' src={child.image} alt={child[`title_${router.locale}`]} />
                            </a>
                          ))
                        }
                      </div>
                    </SwiperSlide>
                  ))
              }
            </Swiper>
          </div>
        </div>
      </Wrapper>
      <style jsx global lang='scss'>
        {
          `
              .lookback .swiper-wrapper :first-child a{
                 background-image: url(/image/lookback-li-first-bg.png);
                 background-size: 100% 100%;
              }
              .lookback .swiper-slide{
                width:auto;
                padding-bottom:20px;
              }
              .swiper-pagination{
                bottom: 0 !important;
              }
              .swiper-pagination-bullet{
                width: 40px;
                height: 6px;
                border-radius: 2px;
                background-color: #231f20;
              }
              .news .swiper-pagination-bullet,
              .exhComment .swiper-pagination-bullet{
                background-color: #ffffff;
              }
              .comment .swiper-pagination{
                text-align:left;
              }
              .comment{
                height:100%;
              }
              .swiper-pagination-bullet-active{
                background-color:#F6A800 !important;
              }
              // .news .swiper-slide{
              //   width:auto !important;
              // }
            `
        }
      </style>
    </div>
  );
};

export default Lookback;
